import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux'
import Tabs from 'devextreme-react/tabs';
import setActionURL from '../../actions/setActionWbdvUrl';
import inspectionIconTitle from '../../images/iconDocInspection.png'
import inspectionIcon from '../../images/inspectionIcon.png'

import '../TaskView/WorkPlace/actionsTa.css';
var selectedIndexTab = 0;
class InspectionPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.onTabsSelectionChanged = this.onTabsSelectionChanged.bind(this);
       
        this.state = {
            selectedIndex: '',
            tabsInspection: [{
                ID: 1,
                text: 'New',

            }, {
                ID: 2,
                text: "Import",

            }]
        };
    }
    componentDidMount() {
        selectedIndexTab = 0
        this.setState({ selectedIndex: '0' })
    }

    onTabsSelectionChanged(args) {
        console.log(args.value)
        selectedIndexTab = args.value
        if (args.name === 'selectedIndex') {

            this.setState({
                selectedIndex: args.value,
            });
        }
    }
    handleSubmit = (event) => {

        event.preventDefault()


        const formData = new FormData()
        formData.append('File', this.state.selectedFile)
        // formData.append('type', 'file');
        //  formData.append('File', 'C:\\test.zip');

        console.log(this.state.selectedFile);

        fetch(


            'http://10.30.0.35:9001/webapi/api/file',

            {
                method: 'POST',
                body: formData,
            }
        )



       
    }
    fileData = () => {
        if (this.state.selectedFile) {

            return (

                <div style={{ fontSize: '14px', marginLeft: '50%', color: '#111', fontWeight: '500', marginTop: '-40px' }}>
                    <h2 style={{ fontSize: '14px', color: '#111', fontWeight: '500' }}>File Name: {this.state.selectedFile.name}</h2>

                    <div style={{ fontSize: '15px', marginLeft: '42px', color: '#111', fontWeight: '500' }}>
                        <button className="submitFile" onClick={this.handleSubmit}>Add File To Server</button>
                    </div>
                </div>

            );
        }
    };
    designerInspection = (e) => {
        
     
        window.open("http://localhost:5001/ManageInspectionForms?edit=false", "_blank", "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=1200, height=1200, top=100 , left = 500")
    }
    importInspection = (e) => {
       

        window.close()
        this.setState({ selectedFile: e.target.files[0] });
        //var actionDetailsVar = 'http://localhost:5000/InspectionIframe'
        var actionDetailsVar = 'http://10.30.0.35:6060/InspectionIframe'

        var dimensionsBDV = '1200'
        this.props.ActionURLset('http://10.30.0.35:6060/InspectionIframe')
        window.open('iframe', actionDetailsVar, "width=" + dimensionsBDV + ",height=" + dimensionsBDV + ",left=500,top=100,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=1,resizable=no");
    }
    handleCloseModal() {
        window.close()
    }
    render() {

        var renderTabContaint;

        if (selectedIndexTab === 0 || this.state.selectedIndex === '0') {
            renderTabContaint = <div className="dx-field">
                <div className="dx-field-label" style={{ marginTop: '-10px', cursor: 'pointer' }}>
                    <img style={{ height: '30px', width: '30px', marginRight: '10px' }} src={inspectionIcon} />
                    <span class="btn btn-primary btn-file" onClick={this.designerInspection} style={{color:'#fff'}}>
                        Create Inspection Form
                    </span>

                </div>
            </div>
        } else {
            renderTabContaint = <div className="dx-field">


                <div className="dx-field-label" style={{ marginTop: '-10px', cursor: 'pointer', width:'227px !important' }} onClick={this.handleSubmit} >
                    <img style={{ height: '30px', width: '30px', marginRight: '10px', cursor: 'pointer' }} src={inspectionIcon} />
                    <span class="btn btn-primary btn-file" style={{ cursor: 'pointer' }}>
                        Import Inspection Form  <input
                            accept=".zip,.rar,.7zip,.html"
                            id="inspection"
                            name="inspection"
                            style={{ cursor: 'pointer' }}
                            type="file"
                            onChange={this.importInspection}
                        />

                    </span>
                    {
                        this.fileData()
                    }

                </div>
            </div>
        }
        const { selectedIndex } = this.state;
        return (
            <div>
                <div>
                    <div className="modal-contentInspection">
                        <span className="closeInspection" onClick={this.handleCloseModal}>&times;</span>
                        <div style={{ width: '100%', border: '1px ,solid , #111' }}>
                            <span style={{ fontSize: '18px', fontWeight: '40', width: '90%', float: 'left' }}>
                                New Form Template

                            </span>
                            <span style={{ fontSize: '18px', fontWeight: '40', float: 'right' }}>
                                <img style={{ height: '30px', width: '30px', marginRight: '10px' }} src={inspectionIconTitle} />

                            </span>
                        </div>
                        <br /><br />
                        <span style={{ fontSize: '14px', fontWeight: '40' }}>
                            Use this facility to create a new draft form template. You can  create from blank document, import
                            an existing document file or create from an existing form template.
                        </span>
                        <hr />
                        <Tabs
                            dataSource={this.state.tabsInspection}
                            selectedIndex={selectedIndex}
                            onOptionChanged={this.onTabsSelectionChanged}
                        />
                        <div className="content dx-fieldset">
                            <div className="dx-field">
                                <div className="dx-field-label">Select a form template technology for your new form template:</div>

                            </div>
                            <div className="dx-field">
                                <div className="dx-field-label" style={{ marginTop: '-10px' }}>Supported Form Technologies:</div>
                            </div>
                            <hr />
                            {renderTabContaint}
                        </div>
                        {/*<div class="modal-footerTaskview" style={{ float: 'right', marginTop: '23px'  }}>

                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Open</button>
                        </div>*/}
                        {/*<div class="modal-footerTaskview" style={{ float: 'right', marginTop: '23px', marginRight:'7px' }}>
                           
                            <button type="button" class="btn btn-default" data-dismiss="modal" onClick={this.handleCloseModal}>Close</button>
                        </div>*/}

                    </div>
                </div>
            </div>
        )
    }
}
const mapDispatchToProps = dispatch => {
    return {
        ActionURLset: payload => dispatch(setActionURL(payload)),
    };
};
export default connect(null,mapDispatchToProps)(InspectionPopUp);



// WEBPACK FOOTER //
// ./src/components/WindowPopUp/InspectionPopUp.js